import { APP_MENU } from '../constants/actions';
import { FLASH } from '../constants/actions';

export const openMenu = () => ({ type: APP_MENU.OPEN });
export const closeMenu = () => ({ type: APP_MENU.CLOSE });

export const openSelectMenu = () => ({ type: APP_MENU.SUB_OPEN });
export const closeSelectMenu = () => ({ type: APP_MENU.SUB_CLOSE });

export function openFlash(message, flashType = 'success') {
    return {
        type: FLASH.OPEN,
        message,
        flashType
    };
}

export function closeFlash() {
    return {
        type: FLASH.CLOSE
    };
}



// WEBPACK FOOTER //
// ./src/actions/global.js